import NotificationsNavItem from './NotificationsNavItem';

export default NotificationsNavItem;
